// Generated from Google's libphonenumber metadata v4 (libphonenumber-js
// metadata.full.json, compiled from the ITU national numbering plans).
// min/max are the possible lengths of the national number (union of the
// fixed-line and mobile types, without country calling code and trunk
// prefix). nationalPrefix is the trunk digit customarily typed before the
// national number (e.g. "0" in 090xxxxxxxx for Japan).

export interface PhoneCountryData {
    dialCode: string;
    minLength: number;
    maxLength: number;
    nationalPrefix?: string;
}

// E.164 fallback bounds, used when no country code is selected
export const DEFAULT_PHONE_MIN_LENGTH = 4;
export const DEFAULT_PHONE_MAX_LENGTH = 15;

export const PHONE_COUNTRY_DATA: { [iso2: string]: PhoneCountryData } = {
    AC: { dialCode: "247", minLength: 5, maxLength: 5 },
    AD: { dialCode: "376", minLength: 6, maxLength: 9 },
    AE: { dialCode: "971", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    AF: { dialCode: "93", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    AG: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    AI: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    AL: { dialCode: "355", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    AM: { dialCode: "374", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    AO: { dialCode: "244", minLength: 9, maxLength: 9 },
    AR: { dialCode: "54", minLength: 10, maxLength: 11, nationalPrefix: "0" },
    AS: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    AT: { dialCode: "43", minLength: 4, maxLength: 13, nationalPrefix: "0" },
    AU: { dialCode: "61", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    AW: { dialCode: "297", minLength: 7, maxLength: 7 },
    AX: { dialCode: "358", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    AZ: { dialCode: "994", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    BA: { dialCode: "387", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    BB: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    BD: { dialCode: "880", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    BE: { dialCode: "32", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    BF: { dialCode: "226", minLength: 8, maxLength: 8 },
    BG: { dialCode: "359", minLength: 6, maxLength: 9, nationalPrefix: "0" },
    BH: { dialCode: "973", minLength: 8, maxLength: 8 },
    BI: { dialCode: "257", minLength: 8, maxLength: 8 },
    BJ: { dialCode: "229", minLength: 10, maxLength: 10 },
    BL: { dialCode: "590", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    BM: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    BN: { dialCode: "673", minLength: 7, maxLength: 7 },
    BO: { dialCode: "591", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    BQ: { dialCode: "599", minLength: 7, maxLength: 7 },
    BR: { dialCode: "55", minLength: 10, maxLength: 11, nationalPrefix: "0" },
    BS: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    BT: { dialCode: "975", minLength: 7, maxLength: 8 },
    BW: { dialCode: "267", minLength: 7, maxLength: 8 },
    BY: { dialCode: "375", minLength: 9, maxLength: 9, nationalPrefix: "8" },
    BZ: { dialCode: "501", minLength: 7, maxLength: 7 },
    CA: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    CC: { dialCode: "61", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    CD: { dialCode: "243", minLength: 7, maxLength: 10, nationalPrefix: "0" },
    CF: { dialCode: "236", minLength: 8, maxLength: 8 },
    CG: { dialCode: "242", minLength: 9, maxLength: 9 },
    CH: { dialCode: "41", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    CI: { dialCode: "225", minLength: 10, maxLength: 10 },
    CK: { dialCode: "682", minLength: 5, maxLength: 5 },
    CL: { dialCode: "56", minLength: 9, maxLength: 9 },
    CM: { dialCode: "237", minLength: 9, maxLength: 9 },
    CN: { dialCode: "86", minLength: 7, maxLength: 11, nationalPrefix: "0" },
    CO: { dialCode: "57", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    CR: { dialCode: "506", minLength: 8, maxLength: 8 },
    CU: { dialCode: "53", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    CV: { dialCode: "238", minLength: 7, maxLength: 7 },
    CW: { dialCode: "599", minLength: 7, maxLength: 8 },
    CX: { dialCode: "61", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    CY: { dialCode: "357", minLength: 8, maxLength: 8 },
    CZ: { dialCode: "420", minLength: 9, maxLength: 9 },
    DE: { dialCode: "49", minLength: 5, maxLength: 15, nationalPrefix: "0" },
    DJ: { dialCode: "253", minLength: 8, maxLength: 8 },
    DK: { dialCode: "45", minLength: 8, maxLength: 8 },
    DM: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    DO: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    DZ: { dialCode: "213", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    EC: { dialCode: "593", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    EE: { dialCode: "372", minLength: 7, maxLength: 8 },
    EG: { dialCode: "20", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    EH: { dialCode: "212", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    ER: { dialCode: "291", minLength: 7, maxLength: 7, nationalPrefix: "0" },
    ES: { dialCode: "34", minLength: 9, maxLength: 9 },
    ET: { dialCode: "251", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    FI: { dialCode: "358", minLength: 5, maxLength: 10, nationalPrefix: "0" },
    FJ: { dialCode: "679", minLength: 7, maxLength: 7 },
    FK: { dialCode: "500", minLength: 5, maxLength: 5 },
    FM: { dialCode: "691", minLength: 7, maxLength: 7 },
    FO: { dialCode: "298", minLength: 6, maxLength: 6 },
    FR: { dialCode: "33", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    GA: { dialCode: "241", minLength: 7, maxLength: 8 },
    GB: { dialCode: "44", minLength: 9, maxLength: 10, nationalPrefix: "0" },
    GD: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    GE: { dialCode: "995", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    GF: { dialCode: "594", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    GG: { dialCode: "44", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    GH: { dialCode: "233", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    GI: { dialCode: "350", minLength: 8, maxLength: 8 },
    GL: { dialCode: "299", minLength: 6, maxLength: 6 },
    GM: { dialCode: "220", minLength: 7, maxLength: 7 },
    GN: { dialCode: "224", minLength: 8, maxLength: 9 },
    GP: { dialCode: "590", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    GQ: { dialCode: "240", minLength: 9, maxLength: 9 },
    GR: { dialCode: "30", minLength: 10, maxLength: 10 },
    GT: { dialCode: "502", minLength: 8, maxLength: 8 },
    GU: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    GW: { dialCode: "245", minLength: 9, maxLength: 9 },
    GY: { dialCode: "592", minLength: 7, maxLength: 7 },
    HK: { dialCode: "852", minLength: 8, maxLength: 8 },
    HN: { dialCode: "504", minLength: 8, maxLength: 8 },
    HR: { dialCode: "385", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    HT: { dialCode: "509", minLength: 8, maxLength: 8 },
    HU: { dialCode: "36", minLength: 8, maxLength: 9 },
    ID: { dialCode: "62", minLength: 7, maxLength: 12, nationalPrefix: "0" },
    IE: { dialCode: "353", minLength: 7, maxLength: 10, nationalPrefix: "0" },
    IL: { dialCode: "972", minLength: 8, maxLength: 12, nationalPrefix: "0" },
    IM: { dialCode: "44", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    IN: { dialCode: "91", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    IO: { dialCode: "246", minLength: 7, maxLength: 7 },
    IQ: { dialCode: "964", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    IR: { dialCode: "98", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    IS: { dialCode: "354", minLength: 7, maxLength: 9 },
    IT: { dialCode: "39", minLength: 6, maxLength: 12 },
    JE: { dialCode: "44", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    JM: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    JO: { dialCode: "962", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    // JP bounds count the digits as typed, trunk "0" included (business rule:
    // 10-11 digits total), so no nationalPrefix adjustment applies on top.
    JP: { dialCode: "81", minLength: 10, maxLength: 11 },
    KE: { dialCode: "254", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    KG: { dialCode: "996", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    KH: { dialCode: "855", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    KI: { dialCode: "686", minLength: 5, maxLength: 8, nationalPrefix: "0" },
    KM: { dialCode: "269", minLength: 7, maxLength: 7 },
    KN: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    KP: { dialCode: "850", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    KR: { dialCode: "82", minLength: 5, maxLength: 10, nationalPrefix: "0" },
    KW: { dialCode: "965", minLength: 8, maxLength: 8 },
    KY: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    KZ: { dialCode: "7", minLength: 10, maxLength: 10, nationalPrefix: "8" },
    LA: { dialCode: "856", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    LB: { dialCode: "961", minLength: 7, maxLength: 8, nationalPrefix: "0" },
    LC: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    LI: { dialCode: "423", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    LK: { dialCode: "94", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    LR: { dialCode: "231", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    LS: { dialCode: "266", minLength: 8, maxLength: 8 },
    LT: { dialCode: "370", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    LU: { dialCode: "352", minLength: 4, maxLength: 11 },
    LV: { dialCode: "371", minLength: 8, maxLength: 8 },
    LY: { dialCode: "218", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    MA: { dialCode: "212", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    MC: { dialCode: "377", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    MD: { dialCode: "373", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    ME: { dialCode: "382", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    MF: { dialCode: "590", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    MG: { dialCode: "261", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    MH: { dialCode: "692", minLength: 7, maxLength: 7, nationalPrefix: "1" },
    MK: { dialCode: "389", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    ML: { dialCode: "223", minLength: 8, maxLength: 8 },
    MM: { dialCode: "95", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    MN: { dialCode: "976", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    MO: { dialCode: "853", minLength: 8, maxLength: 8 },
    MP: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    MQ: { dialCode: "596", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    MR: { dialCode: "222", minLength: 8, maxLength: 8 },
    MS: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    MT: { dialCode: "356", minLength: 8, maxLength: 8 },
    MU: { dialCode: "230", minLength: 7, maxLength: 8 },
    MV: { dialCode: "960", minLength: 7, maxLength: 7 },
    MW: { dialCode: "265", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    MX: { dialCode: "52", minLength: 10, maxLength: 10 },
    MY: { dialCode: "60", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    MZ: { dialCode: "258", minLength: 8, maxLength: 9 },
    NA: { dialCode: "264", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    NC: { dialCode: "687", minLength: 6, maxLength: 6 },
    NE: { dialCode: "227", minLength: 8, maxLength: 8 },
    NF: { dialCode: "672", minLength: 6, maxLength: 6 },
    NG: { dialCode: "234", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    NI: { dialCode: "505", minLength: 8, maxLength: 8 },
    NL: { dialCode: "31", minLength: 9, maxLength: 11, nationalPrefix: "0" },
    NO: { dialCode: "47", minLength: 8, maxLength: 8 },
    NP: { dialCode: "977", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    NR: { dialCode: "674", minLength: 7, maxLength: 7 },
    NU: { dialCode: "683", minLength: 4, maxLength: 7 },
    NZ: { dialCode: "64", minLength: 8, maxLength: 10, nationalPrefix: "0" },
    OM: { dialCode: "968", minLength: 8, maxLength: 8 },
    PA: { dialCode: "507", minLength: 7, maxLength: 8 },
    PE: { dialCode: "51", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    PF: { dialCode: "689", minLength: 8, maxLength: 8 },
    PG: { dialCode: "675", minLength: 7, maxLength: 8 },
    PH: { dialCode: "63", minLength: 6, maxLength: 10, nationalPrefix: "0" },
    PK: { dialCode: "92", minLength: 9, maxLength: 10, nationalPrefix: "0" },
    PL: { dialCode: "48", minLength: 7, maxLength: 9 },
    PM: { dialCode: "508", minLength: 6, maxLength: 9, nationalPrefix: "0" },
    PR: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    PS: { dialCode: "970", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    PT: { dialCode: "351", minLength: 9, maxLength: 9 },
    PW: { dialCode: "680", minLength: 7, maxLength: 7 },
    PY: { dialCode: "595", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    QA: { dialCode: "974", minLength: 8, maxLength: 8 },
    RE: { dialCode: "262", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    RO: { dialCode: "40", minLength: 6, maxLength: 9, nationalPrefix: "0" },
    RS: { dialCode: "381", minLength: 7, maxLength: 12, nationalPrefix: "0" },
    RU: { dialCode: "7", minLength: 10, maxLength: 10, nationalPrefix: "8" },
    RW: { dialCode: "250", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    SA: { dialCode: "966", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    SB: { dialCode: "677", minLength: 5, maxLength: 7 },
    SC: { dialCode: "248", minLength: 7, maxLength: 7 },
    SD: { dialCode: "249", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    SE: { dialCode: "46", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    SG: { dialCode: "65", minLength: 8, maxLength: 8 },
    SH: { dialCode: "290", minLength: 4, maxLength: 5 },
    SI: { dialCode: "386", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    SJ: { dialCode: "47", minLength: 8, maxLength: 8 },
    SK: { dialCode: "421", minLength: 6, maxLength: 9, nationalPrefix: "0" },
    SL: { dialCode: "232", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    SM: { dialCode: "378", minLength: 8, maxLength: 10 },
    SN: { dialCode: "221", minLength: 9, maxLength: 9 },
    SO: { dialCode: "252", minLength: 6, maxLength: 9, nationalPrefix: "0" },
    SR: { dialCode: "597", minLength: 6, maxLength: 7 },
    SS: { dialCode: "211", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    ST: { dialCode: "239", minLength: 7, maxLength: 7 },
    SV: { dialCode: "503", minLength: 8, maxLength: 8 },
    SX: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    SY: { dialCode: "963", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    SZ: { dialCode: "268", minLength: 8, maxLength: 8 },
    TA: { dialCode: "290", minLength: 4, maxLength: 4 },
    TC: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    TD: { dialCode: "235", minLength: 8, maxLength: 8 },
    TG: { dialCode: "228", minLength: 8, maxLength: 8 },
    TH: { dialCode: "66", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    TJ: { dialCode: "992", minLength: 9, maxLength: 9 },
    TK: { dialCode: "690", minLength: 4, maxLength: 7 },
    TL: { dialCode: "670", minLength: 7, maxLength: 8 },
    TM: { dialCode: "993", minLength: 8, maxLength: 8, nationalPrefix: "8" },
    TN: { dialCode: "216", minLength: 8, maxLength: 8 },
    TO: { dialCode: "676", minLength: 5, maxLength: 7 },
    TR: { dialCode: "90", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    TT: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    TV: { dialCode: "688", minLength: 5, maxLength: 7 },
    TW: { dialCode: "886", minLength: 8, maxLength: 9, nationalPrefix: "0" },
    TZ: { dialCode: "255", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    UA: { dialCode: "380", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    UG: { dialCode: "256", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    US: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    UY: { dialCode: "598", minLength: 8, maxLength: 8, nationalPrefix: "0" },
    UZ: { dialCode: "998", minLength: 9, maxLength: 9 },
    VA: { dialCode: "39", minLength: 6, maxLength: 11 },
    VC: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    VE: { dialCode: "58", minLength: 10, maxLength: 10, nationalPrefix: "0" },
    VG: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    VI: { dialCode: "1", minLength: 10, maxLength: 10, nationalPrefix: "1" },
    VN: { dialCode: "84", minLength: 9, maxLength: 10, nationalPrefix: "0" },
    VU: { dialCode: "678", minLength: 5, maxLength: 7 },
    WF: { dialCode: "681", minLength: 6, maxLength: 6 },
    WS: { dialCode: "685", minLength: 5, maxLength: 10 },
    XK: { dialCode: "383", minLength: 8, maxLength: 12, nationalPrefix: "0" },
    YE: { dialCode: "967", minLength: 7, maxLength: 9, nationalPrefix: "0" },
    YT: { dialCode: "262", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    ZA: { dialCode: "27", minLength: 5, maxLength: 9, nationalPrefix: "0" },
    ZM: { dialCode: "260", minLength: 9, maxLength: 9, nationalPrefix: "0" },
    ZW: { dialCode: "263", minLength: 5, maxLength: 10, nationalPrefix: "0" },
};
